import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4526983a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "notification"
}
const _hoisted_2 = ["href"]

import { storeToRefs } from 'pinia';
import { useInfo } from '@/store';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { regionMap } from '@/utils/serveAndRegion';

export default /*#__PURE__*/_defineComponent({
  __name: 'TheNotification',
  setup(__props) {

const { t } = useI18n();
const { redirectHint } = storeToRefs(useInfo());
const isClose = ref(false);
const region = computed(() => {
  if (redirectHint.value) {
    const region = redirectHint.value.region;
    const lang = redirectHint.value.lang;
    const name = regionMap[region]['name'][lang];
    return name;
  }
  return '';
});
const link = computed(() => {
  if (redirectHint.value) {
    const token = localStorage.getItem('TOKEN');
    const map: { [key: string]: string | null } = {
      ['access_token']: token,
      lang: redirectHint.value.lang,
      region: redirectHint.value.region,
    };
    let str = '';
    for (const [key, value] of Object.entries(map)) {
      if (value) {
        str += `&${key}=${value}`;
      }
    }
    return `https://${redirectHint.value.domain}${
      window.location.pathname
    }?${str.slice(1)}`;
  }
  return '';
});
const isSkipNotification = localStorage.getItem('SKIP_NOTIFICATION');
const handleBtnCloseClick = () => {
  isClose.value = true;
  localStorage.setItem('SKIP_NOTIFICATION', 'true');
}

return (_ctx: any,_cache: any) => {
  return (_unref(redirectHint) && !_unref(isSkipNotification) && !isClose.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_unref(t)('IW_REGION', { region: _unref(region) }) || 'IW_REGION'), 1),
        _createElementVNode("a", { href: _unref(link) }, _toDisplayString(_unref(t)('IW_YES') || 'IW_YES'), 9, _hoisted_2),
        _createElementVNode("button", {
          class: "btn-close",
          onClick: handleBtnCloseClick
        }, "╳")
      ]))
    : _createCommentVNode("", true)
}
}

})